export default __webpack_public_path__ + "static/media/sanitizer3.1ec44807.jpg";